<template>
    <div class="header-container home">
        <div class="container-fluid p-0">
            <img src="../assets/images/landing.jpg" alt="Landing" class="w-100">
        </div>
    </div>
    <main class="content home">
        <section class="company-values">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 company-value-wrapper">
                        <div class="company-value-item">
                            <h1 class="title">{{ this.trans("PAGES.HOME.VALUES.TITLE") }}</h1>
                            <ul class="text-list list-unstyled m-0 p-o">
                                <li class="text-list-item" v-for="index in 4" :key="index">
                                    <p>{{ this.trans(`PAGES.HOME.VALUES.P_${index}`) }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 company-value-wrapper">
                        <div class="company-value-item">
                            <h1 class="title">{{ this.trans("PAGES.HOME.PHILOSOPHY.TITLE") }}</h1>
                            <ul class="text-list list-unstyled m-0 p-o">
                                <li class="text-list-item" v-for="index in 3" :key="index">
                                    <p>{{ this.trans(`PAGES.HOME.PHILOSOPHY.P_${index}`) }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 company-value-wrapper">
                        <div class="company-value-item">
                            <h1 class="title">{{ this.trans("PAGES.HOME.MISSION.TITLE") }}</h1>
                            <ul class="text-list list-unstyled m-0 p-o">
                                <li class="text-list-item" v-for="index in 3" :key="index">
                                    <p>{{ this.trans(`PAGES.HOME.MISSION.P_${index}`) }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="company-logo-image">
            <div class="container-fluid p-0">
                <div class="main-img">
                </div>
            </div>
        </section>
        <section class="company-logos">
            <div class="container">
                <div class="row">
                    <div class="company-logos-grid">
                        <div class="company-wrapper" v-for="(item, index) in companies" v-bind:key="index">
                            <a :href="item.link" target="_blank">
                                <div class="company-logo-inside">
                                    <img :src="require(`@/assets/images/companies/${item.image}`)" :alt="item.name"
                                         :width="item.width">
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="button-placeholder mt-5 text-center">
                        <router-link to="/contact">
                            <button class="ax-button outline" type="button">
                                {{ this.trans("TITLES.CONTACT") }}
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    name: "HomeView",
    watch: {
        '$route'() {
            this.$root.setTitle(this.trans('NAV_ITEMS.HOME'))
        }
    },
    mounted() {
        this.$root.setTitle(this.trans('NAV_ITEMS.HOME'))
        setTimeout(() => {
            window.scroll(0, 0);
        }, 100)
    },
    data: function () {
        return {
            companies: [
                {
                    name: "IFLR",
                    image: "download-12.png",
                    link: "https://www.iflr1000.com/Firm/Polenak-Law-Firm/Profile/2874#profile",
                    width: 90,
                    height: 150,
                },
                {
                    name: "EMEA Top Tier",
                    image: "emea-top-tier-firms-2021.jpg",
                    link: "https://www.legal500.com/firms/16244-polenak-law-firm/17168-skopje-north-macedonia/#firm_profiles",
                    width: 100,
                    height: 150,
                },
                {
                    name: "Chambers Global",
                    image: "Chambers-Global-2022.jpg",
                    link: "https://chambers.com/law-firm/polenak-law-firm-global-2:79121",
                    width: 120,
                    height: 120,
                },
                {
                    name: "Chambers Europe",
                    image: "Chambers Europe_2022.jpg",
                    link: "https://chambers.com/law-firm/polenak-law-firm-europe-7:79121",
                    width: 120,
                    height: 100,
                },
                {
                    name: "WSG",
                    image: "wsg.jpg",
                    link: "https://www.worldservicesgroup.com/member/law-firm/polenak-law-firm/10104",
                    width: 140,
                    height: 100,
                },
                {
                    name: "SEE Legal",
                    image: "SEE-legal.jpg",
                    link: "https://seelegal.org/our-team/north-macedonia/",
                    width: 120,
                    height: 100,
                },
            ],
        }
    },
}
</script>

<style scoped>

</style>